import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { User, Shield, TicketPercent } from "lucide-react";
import Profile from "./Profile";
import DiscountCodesSettings from "./DiscountCodesSettings";
import useDiscountCodesConfig from "hooks/useDiscountCodesConfig/useDiscountCodesConfig";

function Settings() {
  const [searchParams] = useSearchParams();
  const { enabled: codesEnabled } = useDiscountCodesConfig();
  // Deep link ?tab=discount-codes selects the codes tab (ui-spec §2.1.6).
  const [activeTab, setActiveTab] = useState(
    searchParams.get("tab") === "discount-codes" ? "discount-codes" : "profile"
  );

  const tabs = [
    { id: "profile", name: "Profile", icon: User },
    { id: "security", name: "Security", icon: Shield },
    // Hidden while the discount codes switch is off or unknown.
    ...(codesEnabled
      ? [{ id: "discount-codes", name: "Discount codes", icon: TicketPercent }]
      : []),
  ];
  // Without the switch the codes tab falls back to Profile.
  const shownTab =
    activeTab === "discount-codes" && !codesEnabled ? "profile" : activeTab;

  return (
    <div className="space-y-8 mx-auto">
      <div>
        <h1 className="text-2xl font-bold tracking-tight">Settings</h1>
        <p className="text-muted-foreground text-sm">
          Manage your account settings and preferences.
        </p>
      </div>

      <div className="flex flex-col md:flex-row gap-8">
        <aside className="w-full md:w-56 space-y-1">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              type="button"
              onClick={() => setActiveTab(tab.id)}
              className={`flex w-full items-center px-4 py-2.5 text-sm font-medium rounded-xl transition-all duration-200 ${shownTab === tab.id ? "bg-primary text-primary-foreground" : "text-muted-foreground hover:bg-muted hover:text-foreground"}`}
            >
              <tab.icon className="mr-3 h-4 w-4" />
              {tab.name}
            </button>
          ))}
        </aside>

        <div className="flex-1 animate-in">
          {shownTab === "profile" && <Profile />}
          {shownTab === "security" && (
            <div className="rounded-2xl border border-border/50 bg-card p-6 md:p-8 shadow-card">
              <h3 className="font-bold">Security</h3>
              <p className="text-sm text-muted-foreground mt-2">
                Security options will be available here soon.
              </p>
            </div>
          )}
          {shownTab === "discount-codes" && <DiscountCodesSettings />}
        </div>
      </div>
    </div>
  );
}

export { Settings as default };
